import ViralLoopItem from './ViralLoopItem';

export default ViralLoopItem;
